import { DateFormatter } from '@repo/toolkit/date'
import { AvailableLanguages } from '@repo/toolkit/language-types'
import { TFunction } from 'i18next'

import { outingDurationEnumMapping } from '../../enums/cultural-outing/outing-duration.enum'
import { CulturalOuting } from '../center/center-cultural-outing'

export class CulturalOutingProperties {
  static getLabel(outing: CulturalOuting, t: TFunction<AvailableLanguages, undefined>): string {
    const output: string[] = []

    if (outing.coachCompany?.name) output.push(outing.coachCompany.name)
    if (outing.activity?.name) output.push(outing.activity.name)
    if (outing.duration) output.push(t(outingDurationEnumMapping[outing.duration]))
    if (outing.numberOfSeats) output.push(`${outing.numberOfSeats} seats`)
    if (outing.validUntil) output.push(`valid until ${DateFormatter.DDMMYYYY(outing.validUntil)}`)

    return output.join(' - ')
  }
}
